export interface BasicLayoutRouteDataConfig {
  showFooter?: boolean;
  showMobileAppFooter?: boolean;
  authenticatedHeader?: boolean;
  showHeaderHamburger?: boolean;
  headerBackground?: 'filled' | 'transparent';
  showHeaderLinks?: boolean;
  showFooterLinks?: boolean;
  onlyLogoHeader?: true;
  bottomSpacing?: boolean;
  previewOnlyHeaderText?: boolean;
  authOnly?: {
    authFallback: BasicLayoutRouteDataConfig
  };
}

export enum NewInvestmentRoute {
  NEW_INVESTMENT = 'new-investment',
  INVESTMENT_GOAL = 'investment-goal',
  NEW_INVESTMENT_SETTINGS = 'investment-settings',
  INVESTMENT_TYPE = 'investment-type',
  INSTRUMENTS_SELECT = 'instruments-select',
  INSTRUMENTS_WEIGHTS = 'instruments-weights',
  SUCCESS = 'success',
  FIRST_SIGN_IN = 'first-sign-in',
}

export enum EditInvestmentRoute {
  EDIT_INVESTMENT = 'edit-investment',
  EDIT_INVESTMENT_SETTINGS = 'investment-settings',
  INSTRUMENTS_SELECT = 'instruments-select',
  INSTRUMENTS_WEIGHTS = 'instruments-weights',
  SUCCESS = 'success',
  EFEKTIKA = 'efektika',
}

export const BasicLayoutRouteConfig = {
  data: {
    showFooter: false,
    authenticatedHeader: true,
    showHeaderHamburger: true,
    showHeaderLinks: true,
    bottomSpacing: true,
    showMobileAppFooter: true,
  } satisfies BasicLayoutRouteDataConfig,
};

export const PublicAccessibleRoutesLayoutRouteConfig = {
  data: {
    showFooter: false,
    bottomSpacing: true,
    showMobileAppFooter: true,
    authenticatedHeader: false,
    showHeaderLinks: false,
    showHeaderHamburger: false,
  } satisfies BasicLayoutRouteDataConfig,
};

export enum InitSignRoute {
  INIT_SIGN_WITH_INVESTMENTS = 'initial-investment',
  INIT_REGULAR_DEPOSIT = 'regular-deposit',
  INIT_ENTRY_FEE = 'entry-fee',
}

export enum OauthRoute {
  BCAS_CALLBACK = 'oauth/bcas/callback',
}

export enum AuthRoute {
  LOGIN = 'login',
}

export enum DashboardRoute {
  DASHBOARD = 'dashboard'
}

export enum ProductsRoute {
  INVESTMENT_DETAIL = 'investment-detail'
}

export enum DocumentsRoute {
  DOCUMENTS = 'documents',
  DOCUMENTS_LISTINGS = 'listings',
}

export enum DraftInvestmentRoute {
  DRAFT_INVESTMENT = 'draft-investment',
  REFUSE_SUCCESS = 'refuse-success',
  DETAIL = 'detail',
  RESOLVE = 'resolve',
}

export enum InvestmentChangeDraftRoute {
  INVESTMENT_CHANGE_DRAFT = 'investment-change-draft',
  REFUSE_SUCCESS = 'refuse-success',
  DETAIL = 'detail',
  RESOLVE = 'resolve',
}

export enum AccountRoute {
  ACCOUNT = 'account',
  PERSONAL_INFORMATION = 'personal-information',
  OWN_STRATEGIES_DECLARATION = 'strategies-declaration',
  OWN_STRATEGIES_DECLARATION_SUCCESS = 'strategies-declaration-send',
  SETTINGS = 'settings',
  DARK_MODE = 'dark-mode',
}

export enum FaqRoute {
  FAQ = 'faq'
}

export enum InvestmentProfileRoute {
  INVESTMENT_PROFILE = 'investment-profile'
}

export enum MoneyAndTransactionsRoute {
  MONEY_TRANSACTIONS = 'money',
  TRANSACTIONS_LIST = 'transactions-list',
  TRANSACTIONS_DETAIL = 'transaction-detail',
  DEPOSITS = 'deposits',
  NEW_DEPOSIT = 'new-deposit',
  WITHDRAWAL = 'withdrawal',
  WITHDRAWAL_SELECT_PORTFOLIO = 'select-portfolio',
  WITHDRAWAL_PORTFOLIO = 'portfolio',
  WITHDRAWAL_SUMMARY = 'summary',
  WITHDRAWAL_SUCCESS = 'success',
  WITHDRAWAL_DIP_CONFIRMATION = 'dip-confirmation',
  REGULAR = 'regular', // variant
  REGULAR_WITHDRAWALS = 'regular-withdrawals',
  REFUSE_SUCCESS = 'refuse-success',
  REGULAR_WITHDRAWAL_DIP_CONFIRMATION = 'regular-dip-confirmation',
}

export enum CollaboratorRoute {
  COLLABORATOR = 'collaborator',
  SUCCESS = 'success'
}

export enum InvestmentsListRoute {
  INVESTMENTS = 'investments'
}

export enum BlogRoute {
  BLOG = 'blog',
}

export enum ThematicStrategiesRoute {
  THEMATIC_STRATEGIES = 'thematic-strategies'
}

export enum PersonalInformationRoute {
  PERSONAL_INFORMATION = 'personal-information'
}

export enum UserNotificationsRoute {
  USER_NOTIFICATIONS = 'user-notifications',
  DETAIL = 'detail',
}

// routes available without login
export enum UnauthRoutes {
  DIP_REDIRECT = 'dip-redirect',
  CLIENT_ADDITION_REDIRECT = 'client-addition-redirect',
  EMAIL_VERIFICATION = 'email-verification/confirm',
  PUBLIC_INSTRUMENTS = 'prehled-instrumentu',
  NOTIFICATIONS_UNSUBSCRIBE = 'notification',
  // COOKIE_TEXT = 'cookie-text', todo
  // todo - should article route be here? its already working unauth
  // BLOG_PREVIEW = 'blog-preview', todo
}

export enum ProductLandingRoute {
  PRODUCT = 'product-landing',
  THEMATIC_STRATEGY = 'thematic-strategy',
  CUSTOM_STRATEGY = 'custom-strategy',
}

export const LOGIN_REDIRECT_PATH = `/${DashboardRoute.DASHBOARD}`;
export const LOGIN_REDIRECT_FIRST_SIGN_IN_CREATE_INVESTMENT_PATH = `/${NewInvestmentRoute.NEW_INVESTMENT}/${NewInvestmentRoute.INVESTMENT_GOAL}/${NewInvestmentRoute.FIRST_SIGN_IN}`;
